import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { favoritesAssignWidgetReducer } from '@cian/favorites-assign-widget';

import {
  filtersReducer as marketTrendsFilters,
  marketTrendsDataReducer,
  marketTrendsStatusReducer,
} from 'shared/slices/marketTrends';

import { IApplicationContext } from 'shared/types/applicationContext';
import { IPreloadedState } from 'shared/types/redux';
import { createSimpleReducer } from './createSimpleReducer';
import { INearbyHousesInfo, TSupplyDemand, IAvailableFilters, IMarketTrends } from 'shared/types/marketTrends';
import { IHouseInfo } from 'shared/types/houseInfo';
import { offersHistoryReducer } from 'shared/slices/offersHistory';
import { userReducer } from 'shared/slices/user';
import { IManagementCompany } from 'shared/types/managementCompany';
import { offersReducer } from 'shared/slices/offers';
import { infrastructureReducer } from 'shared/slices/infrastructure';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReduxStore(context: IApplicationContext, preloadedState: IPreloadedState, debugEnabled: boolean) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      houseInfo: createSimpleReducer<IHouseInfo>({} as IHouseInfo),
      marketTrends: combineReducers<IMarketTrends>({
        filters: marketTrendsFilters,
        filtersAvailability: createSimpleReducer<IAvailableFilters>({}),
        marketTrendsData: marketTrendsDataReducer,
        marketTrendsStatus: marketTrendsStatusReducer,
        supplyDemand: createSimpleReducer<TSupplyDemand | null>(null),
        nearbyHousesInfo: createSimpleReducer<INearbyHousesInfo[]>([]),
      }),
      offersHistory: offersHistoryReducer,
      user: userReducer,
      managementCompany: createSimpleReducer<IManagementCompany | null>(null),
      infrastructure: infrastructureReducer,
      offers: offersReducer,
      favoritesAssignWidget: favoritesAssignWidgetReducer,
    },
  });
}
